import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FeaturedContentComponent } from '@components';
import { ProductUid } from '@constants';
import { AuthedDirective, UnauthedDirective } from '@directives';
import { environment } from '@environments/environment';
import { ContentService, OrchestratorsFeaturedContent, ProductService } from '@services';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { ProfileBannerComponent } from '../@shared/components/profile-banner/profile-banner.component';
import { ChildPageRoute } from '../app-routing.enum';
import { HomeBadgesComponent } from './home-badges/home-badges.component';
import { HomeFavoritesComponent } from './home-favorites/home-favorites.component';
import { FundamentalsComponent } from './home-fundamentals/home-fundamentals.component';
import { HomeHeroComponent } from './home-hero/home-hero.component';
import { HomeJumpBackInComponent } from './home-jump-back-in/home-jump-back-in.component';
import { HomeLeaderboardComponent } from './home-leaderboard/home-leaderboard.component';
import { HomeRecentlyViewedComponent } from './home-recently-viewed/home-recently-viewed.component';
import { HomeRecommendationsComponent } from './home-recommendations/home-recommendations.component';
import { HomeSearchCtaBannerComponent } from './home-search-cta-banner/home-search-cta-banner.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [
        CommonModule,
        AuthedDirective,
        HomeBadgesComponent,
        FeaturedContentComponent,
        FundamentalsComponent,
        HomeJumpBackInComponent,
        HomeLeaderboardComponent,
        HomeFavoritesComponent,
        HomeRecentlyViewedComponent,
        HomeRecommendationsComponent,
        HomeHeroComponent,
        HomeSearchCtaBannerComponent,
        ProfileBannerComponent,
        UnauthedDirective,
    ],
})
export class HomeComponent implements OnInit {
    private contentService = inject(ContentService);
    private productService = inject(ProductService);

    showCustomerAssistant$ = new BehaviorSubject(false);
    /** optional featured content from wordpress */
    featuredContent$: Observable<OrchestratorsFeaturedContent>;
    unsignedHomeFeaturedContent$: Observable<OrchestratorsFeaturedContent>;

    selectedProduct$: Observable<ProductUid>;

    ngOnInit(): void {
        this.showCustomerAssistant$.next(environment.featureFlags.digitalAssistant.enabled);
        this.featuredContent$ = this.contentService.featuredContent$();
        this.unsignedHomeFeaturedContent$ = this.contentService.featuredContent$(ChildPageRoute.HOME);
        this.selectedProduct$ = this.productService.selectedProduct$.pipe(map((product) => product.uid));
    }
}
